<template>
  <div class="enrolling-log-item-wrap">
    <div class="log-item-wrap-cont">
      <div class="title">{{log.title}}</div>
      <div class="content" ref="logContent"></div>
      <div class="operate-user">操作人：{{log.operateUser}}</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import LogLink from './link'
export default {
  name: 'EnrollingLogItemWrap',
  props: {
    log: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleLogContent () {
      let log = this.log.log
      if (log) {
        this.$nextTick(() => {
          let logContent = this.$refs['logContent']
          if (logContent) {
            let OperateLogWrap = Vue.extend({
              template: `<div>${log}</div>`,
              components: {LogLink}
            })
            new OperateLogWrap().$mount(logContent, true)
          }
        })
      }
    }
  },
  mounted () {
    this.handleLogContent()
  }
}
</script>
<style lang="scss">
.enrolling-log-item-wrap {
  & > .log-item-wrap-cont {
    padding: 15px;
    background-color: #fff;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    & > .title {
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    }
    & > .content {
      margin-top: 10px;
      font-size: 13px;
      color: #999;
      line-height: 1.8;
      background-color: #f9f9f9;
      box-shadow: inset 0 0 8px rgba(0,0,0,.05);
      border-radius: 4px;
      word-break: break-all;
      word-wrap: break-word;
      padding: 10px;
      p {
        margin: 5px auto;
        color: #333;
      }
    }
    & > .operate-user {
      margin-top: 10px;
      color: #999;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>
